module.exports = __webpack_public_path__ + "static/media/add-photo-icon-colored.6b2644ac.svg";